<template>
  <div :class="$style['paid-order-list']">
        <pt-page-title title="已支付订单"></pt-page-title>
        <pt-page-factor-filter :labels="filterLabels" v-model="params"  isQueryRouter ref="filter" @Filter="Filter">
            <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="primary" @click="exportPaidOrder" :loading="exportLoading">导出</el-button>
            <el-button type="primary" @click="exportPaidOrderHistory">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
            </template>
        </pt-page-factor-filter>
        <order-table :queryParams="queryParams" :pageSize="pageSize" ref="table" :class="$style['order-table']" :isFromRouter="isFromRouter">
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" v-if="needShiping(scope.row)" @click="sendGoods(scope.row)">发货</el-button>
                    <el-button type="text" v-if="needRefund(scope.row)" @click="refund(scope.row)">退款</el-button>
                    <el-button  type="text" @click="getOrderDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </order-table>
        <el-dialog :visible="is_dialog" :title="dialog_title" @close="closeDialog">
        <sampling-message :isList="true" @getOrderList="getOrderList" :order-id="send_id" @close="closeDialog" :orderDetail="orderDetail"></sampling-message>
      </el-dialog>
  </div>
</template>

<script>
import { paidOrderLabels } from '../goods-order-options.js'
import orderTable from '../pt-order-table/withData.vue'
import samplingMessage from '../pt-order-detail/sampling-message'
import { emptyObject } from '@/utils/lifebankUtils'
import { hasPermissions } from 'utils/permissions'
// 操作订单权限
const PERM_MALLSALES_ORDER_MANAGEMENT = 'PERM_MALLSALES_ORDER_MANAGEMENT'
// 组件class前缀
const prefixCls = 'pt-paid-order-list'

export default {
  name: 'pt-paid-order-list',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_send
      },
      set: function (val) {
        this.is_send = val
      }
    },
    page () {
      return this.$refs.table.page
    },
    tableData () {
      return this.$refs.table.tableData
    },
    // 操作订单权限
    HAS_ORDER_MANAGEMENT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_ORDER_MANAGEMENT)
    }
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    exportLoading: {
      type: Boolean,
      default: false
    },
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    },
    goodsTypeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    vendorsOrganizations: {
      type: Array,
      default: function () {
        return []
      }
    },
    orderOrganization: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      filterLabels: paidOrderLabels,
      params: {},
      queryParams: {
        orderStatus: 'PAID'
      },
      is_send: false,
      dialog_title: '',
      send_id: '',
      orderDetail: {},
      isFromRouter: false
    }
  },
  watch: {
    groupList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'goodsGroupName') {
            item.options = val
          }
        })
      },
      deep: true
    },
    goodsTypeList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'goodsType') {
            this.$set(item, 'options', val)
          }
        })
      },
      deep: true
    },
    vendorsOrganizations: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'organizationName') {
            this.$set(item, 'options', val)
          }
        })
      }
    },
    orderOrganization: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'orderOrganizationId') {
            this.$set(item, 'options', val)
          }
        })
      },
      deep: true
    }
  },
  components: {
    orderTable,
    samplingMessage
  },
  methods: {
    exportPaidOrderHistory () {
      this.$router.push('/export-history/order?name=mall_order_export')
    },
    // 导出待支付订单列表
    exportPaidOrder () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          for (var key in this.params) {
            if (!this.params[key]) {
              this.$delete(this.params, key)
            }
            if (key === 'createdtime') {
              this.$delete(this.params[key], 'index')
              this.params = { ...this.params, ...this.params[key] }
              this.$delete(this.params, key)
            }
          }
          let queryParams = JSON.stringify(this.params) !== '{}' ? { ...this.params } : {}
          queryParams.orderStatus = 'PAID'
          queryParams.paidExport = true
          this.$emit('exportPaidOrder', queryParams)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    // 是否需要发货按钮
    needShiping (val) {
      return val.requirements && val.requirements.requireShipping && this.needRefund(val) && val.type !== 'CONTRACT' && this.HAS_ORDER_MANAGEMENT
    },
    // 是否需要退款按钮
    needRefund (val) {
      return !(val.refundmentDetails && val.refundmentDetails.apply) && this.HAS_ORDER_MANAGEMENT
    },
    refund (val) {
      this.$router.push('/mall-order-all/order-detail/' + val.id + '/refund')
    },
    getOrderDetail (val) {
      this.$router.push('/mall-order-all/order-detail/' + val.id + '/detail')
    },
    cleanParams () {
      emptyObject(this.params)
      this.Filter()
    },
    getOrderList () {
      this.$refs.table.getOrderList(0)
      this.is_send = false
    },
    closeDialog () {
      this.is_send = false
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'createdtime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
      this.queryParams = JSON.stringify(this.params) !== '{}' ? { ...this.params } : {}
      this.queryParams.orderStatus = 'PAID'

      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
    },
    sendGoods (val) {
      this.orderDetail = val
      this.is_send = true
      this.dialog_title = '订单发货'
      this.send_id = val.id
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.paid-order-list{
    :global
    .el-dialog{
        width: 50%;
        min-width:700PX;
        max-width: 800PX;
        .el-dialog__body{
            padding: 0 20px 30px
        }
    }
}
.order-table{
    :global
    .el-button{
        margin-left: 0;
        margin-right: 10px;
    }
}
</style>
